export const modules = {
  Dashboard: "ACCOUNTING_DASHBOARD",
  ChartOfAccounts: "CHART_OF_ACCOUNTS",
  JournalEntries: "JOURNAL_ENTRIES",
  TrialBalance: "TRIAL_BALANCE",
  GeneralLedger: "GENERAL_LEDGER",
  IncomeStatement: "INCOME_STATEMENT",
  AccountingSettings: "ACCOUNTING_SETTINGS",
  Treasury: "TREASURY",
} as const;

export const app = {
  Accounting: "ACCOUNTING",
  Sales: "SALES",
  Storage: "STORAGE",
} as const;

export const baseURL = process.env.REACT_APP_PORTAL_URL || "http://localhost:3000";

export const contentPath = {
  [modules.Dashboard]: "/dashboard",
  [modules.ChartOfAccounts]: "/chart-of-accounts",
  [modules.JournalEntries]: "/journal-entries",
  [modules.TrialBalance]: "/trial-balance",
  [modules.GeneralLedger]: "/general-ledger",
  [modules.IncomeStatement]: "/income-statement",
  [modules.AccountingSettings]: "/settings",
  [modules.Treasury]: "/treasury",
} as const;

export const permissionMap: Record<string, string> = {
  [modules.Dashboard]: "accounting.menu.view.dashboard",
  [modules.ChartOfAccounts]: "accounting.menu.view.chart_of_accounts",
  [modules.JournalEntries]: "accounting.menu.view.journal_entries",
  [modules.TrialBalance]: "accounting.menu.view.trial_balance",
  [modules.GeneralLedger]: "accounting.menu.view.general_ledger",
  [modules.IncomeStatement]: "accounting.menu.view.income_statement",
  [modules.AccountingSettings]: "accounting.menu.view.settings",
  [modules.Treasury]: "accounting.menu.view.treasury",
};

export const actions = {
  CreateAccount: "accounting.action.accounts.create",
  UpdateAccount: "accounting.action.accounts.update",
  UpdateConfigs: "accounting.action.configs.update",
  CreateEntry: "accounting.action.entries.create",
  ReprocessEntries: "accounting.action.entries.reprocess",
  CreateTreasuryMovement: "accounting.action.treasury.movements",
  ManageTreasuryAccounts: "accounting.action.treasury.manage",
} as const;

export const isViewAllowed = (moduleKey: string, userViews: string[] = []): boolean => {
  if (!userViews || userViews.length === 0) return false;
  const permKey = permissionMap[moduleKey]?.toLowerCase();
  const modLower = moduleKey.toLowerCase();
  return userViews.some((v: string) => {
    const vLower = v.toLowerCase();
    return (
      (permKey && (vLower === permKey || vLower.includes(permKey))) ||
      vLower.includes(modLower) ||
      (modLower.includes('dashboard') && vLower.includes('dashboard')) ||
      (modLower.includes('settings') && vLower.includes('settings'))
    );
  });
};

export const isActionAllowed = (actionKey: string, userActions: string[] = []): boolean => {
  if (!userActions || userActions.length === 0) return false;
  const actLower = actionKey.toLowerCase();
  return userActions.some((a: string) => a.toLowerCase().includes(actLower));
};

